import { EmptySearchComponent } from './empty-search.component';

export default angular
  .module('sfMobile.components.empty-search', [
    'pascalprecht.translate',
    'sfMobile.templates',
    'sfMobile.components.information-display',
  ])
  .component('sfEmptySearch', EmptySearchComponent).name;
